import { ComponentProps, ComponentPropsWithoutRef } from 'react';

import { cn, useAutoFocusInput } from '../lib';
import { InputOTP, InputOTPGroup, InputOTPSlot } from './input-otp';

export type OTPProps = {
  length: number;
  error?: boolean;
  slotVariant?: ComponentProps<typeof InputOTPSlot>['variant'];
} & Omit<ComponentPropsWithoutRef<typeof InputOTP>, 'render' | 'maxLength'>;

export const OTP = ({
  length,
  error,
  slotVariant,
  disabled,
  ...props
}: OTPProps) => {
  const { ref, props: autoFocusProps } = useAutoFocusInput();

  return (
    <InputOTP {...props} maxLength={length} ref={ref} {...autoFocusProps}>
      {Array(length)
        .fill(0)
        .map((_, idx) => (
          <InputOTPGroup key={idx}>
            <InputOTPSlot
              className={cn(
                { 'border-negative-500 bg-negative-300': error },
                { 'opacity-50': disabled },
                'w-10',
              )}
              variant={slotVariant}
              index={idx}
            />
          </InputOTPGroup>
        ))}
    </InputOTP>
  );
};
